<template>
  <div class="health-image-detail-page">
    <!-- 顶部导航栏 -->
    <!-- <div class="nav-bar">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <span class="nav-title">详情</span>
    </div> -->

    <!-- 图片容器 -->
    <div class="image-wrapper">
      <!-- 加载中提示 -->
      <div v-if="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 缩略图（模糊背景） -->
      <div
        v-if="showThumbnail && !imageLoaded"
        class="thumbnail-bg"
        :style="{ backgroundImage: `url(${thumbnailUrl})` }"
      ></div>

      <!-- 原图 -->
      <img
        v-show="imageLoaded"
        :src="imageUrl"
        alt="详情图片"
        class="detail-image"
        @load="onImageLoad"
        @error="onImageError"
      />

      <!-- 加载失败提示 -->
      <div v-if="loadError" class="error-container">
        <p>图片加载失败</p>
        <button @click="retryLoad" class="retry-btn">重新加载</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';

export default {
  name: 'HealthImageDetail',
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      imageUrl: '',
      isLoading: true,
      imageLoaded: false,
      loadError: false,
      showThumbnail: true,
      thumbnailUrl: ''
    };
  },
  created() {
    // 从路由参数获取图片URL
    this.imageUrl = this.$route.query.imageUrl || 'https://video.pacsonline.cn/value/20251216.jpg';
    this.loadImage();
  },
  methods: {
    loadImage() {
      this.isLoading = true;
      this.imageLoaded = false;
      this.loadError = false;
      this.showThumbnail = true;

      // 生成缩略图
      this.generateThumbnail();
    },
    generateThumbnail() {
      // 创建一个canvas来生成模糊的缩略图
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = this.imageUrl;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置较小的尺寸作为缩略图
        const maxSize = 100;
        const scale = Math.min(maxSize / img.width, maxSize / img.height);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        // 绘制缩略图
        ctx.filter = 'blur(10px)';
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        this.thumbnailUrl = canvas.toDataURL('image/jpeg', 0.5);
        this.isLoading = false;
      };

      img.onerror = () => {
        // 如果无法加载缩略图，直接显示加载状态
        this.isLoading = true;
        this.showThumbnail = false;
      };
    },
    onImageLoad() {
      this.imageLoaded = true;
      this.isLoading = false;
      this.loadError = false;
    },
    onImageError() {
      this.isLoading = false;
      this.loadError = true;
      this.showThumbnail = false;
    },
    retryLoad() {
      this.loadImage();
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.health-image-detail-page {
  width: 100%;
  min-height: 100vh;
  background: #000;
  position: relative;
}

.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 46px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
}

.back-icon {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  margin-right: 20px;
}

.image-wrapper {
  width: 100%;
  min-height: 100vh;
  /* padding-top: 46px; */
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.thumbnail-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(30px);
  transform: scale(1.1);
  opacity: 0.5;
  pointer-events: none;
}

.detail-image {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 1;
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 2;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  margin: 0;
  font-size: 14px;
}

.error-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 2;
}

.error-container p {
  margin: 0 0 15px;
  font-size: 14px;
}

.retry-btn {
  padding: 8px 20px;
  background: #3B9FCC;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.retry-btn:active {
  opacity: 0.8;
}
</style>
